export default __webpack_public_path__ + "static/media/dashboard_icon_white.4509a05b.svg";